import React, { useMemo, useState } from 'react';
import { NoData, Skelton, Table } from 'src/@vymo/ui/blocks';
import { getRevyreConfig } from 'src/models/lmsConfig/selectors';
import { REVYRE_DETAILS_360 } from 'src/modules/constants';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { renderModule } from 'src/workspace/slice';
import { TAB_STATUS_KEYS } from '../../constant';
import { getStatus, getTotalTrails, getTrails } from '../../selector';
import { fetchTrails } from '../../thunk';
import { getTrailsColumns } from './queries';
import styles from '../../index.module.scss';

function Trails(props) {
  const { entityId } = props;
  const dispatch = useAppDispatch();
  const trails = useAppSelector(getTrails);
  const revyreConfig = useAppSelector(getRevyreConfig);
  const columns: any = useMemo(
    () => getTrailsColumns(revyreConfig),
    [revyreConfig],
  );
  const status = useAppSelector((state) =>
    getStatus(state, TAB_STATUS_KEYS.TRAILS),
  );
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const totalCount: number = useAppSelector(getTotalTrails);
  const [sortBy, setSortBy] = useState<string>('');
  const [sortType, setSortType] = useState<string>('');

  const filters = {
    workflowId: entityId,
  };
  return (
    <div className={styles.detailsWrapper__detailsBody__trails}>
      {status === 'loading' && <Skelton rounded lines={8} />}
      {status === 'error' && <NoData message="Error fetching entity details" />}
      {status === 'done' && (
        <Table
          isAccordion={false}
          tableData={trails}
          columnConfigs={columns}
          tableConfig={{
            showSearch: false,
            isRowSelectionEnabled: false,
            name: '',
            pagination: {
              visible: true,
              pageSize,
              totalPages: Math.max(1, Math.ceil(totalCount / pageSize)),
              currentPage,
              totalItems: totalCount,
            },
            onRowClick: (rowId) => {
              dispatch(
                renderModule({
                  id: REVYRE_DETAILS_360,
                  props: {
                    domainType: 'activity',
                    entityId: rowId,
                  },
                }),
              );
            },
          }}
          onSort={(sortedColumns) => {
            const [sortedColumn] = sortedColumns ?? [];

            if (!sortedColumn) return;

            const { id: columnSortBy, desc } = sortedColumn;
            const columnSortType = desc ? 'desc' : 'asc';
            setSortBy(columnSortBy);
            setSortType(columnSortType);
            dispatch(
              fetchTrails({
                props,
                payload: {
                  sortBy: columnSortBy,
                  sortType: columnSortType,
                  filters,
                  page: {
                    pageSize,
                    pageNumber: 1,
                  },
                },
              }),
            );
          }}
          onChangePageSize={(updatedPageSize) => {
            setPageSize(updatedPageSize);
            dispatch(
              fetchTrails({
                props,
                payload: {
                  sortBy,
                  sortType,
                  filters,
                  page: {
                    pageSize: updatedPageSize,
                    pageNumber: 1,
                  },
                },
              }),
            );
          }}
          onChangePageIndex={(pageIndex) => {
            setCurrentPage(Number(pageIndex) + 1);
            dispatch(
              fetchTrails({
                props,
                payload: {
                  sortBy,
                  sortType,
                  filters,
                  page: {
                    pageSize,
                    pageNumber: Number(pageIndex) + 1,
                  },
                },
              }),
            );
          }}
        />
      )}
    </div>
  );
}

export default Trails;
